import React from "react";
import styles from "./index.module.css";
import UserCard from '../UserCard/UserCard'



const LargeRigthLine = () => {
  return (
    <div className={styles.lineC}>
      <div className={styles.top}>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="122"
          height="543"
          viewBox="0 0 122 543"
          fill="none"
        >
          <path
            d="M2 0.501465V179.503M122 541.003H10C5.58172 541.003 2 537.421 2 533.003V360.253M2 179.503H122M2 179.503V360.253M2 360.253H122"
            stroke="#10C237"
            stroke-width="3"
          />
        </svg>
      </div>

      <div className={styles.bottom}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="122"
          height="218"
          viewBox="0 0 122 218"
          fill="none"
        >
          <path
            d="M2 0.00195312V208.002C2 212.42 5.58172 216.002 10 216.002H122"
            stroke="#10C237"
            stroke-width="3"
            stroke-dasharray="6 6"
          />
        </svg>
      </div>
      <UserCard/>
    </div>
  );
};

export default LargeRigthLine;
